
let constants ={
    URL_FONDUE : 'https://fondue.traffy.in.th/fondue/',
    REPORTED_TOS : '?reported_tos=',
    FACEBOOK_ID : '1758921471099386',
    COLOR_PRIMARY: '#694325',
    // 138 ..
}
export default constants


// WEBPACK FOOTER //
// ./src/components/constants.js